<div class="tenure-adjustment-container">
    @if(beginRender){
    <app-page-container [DataTableSchema]="dataTableSchema" [dynamicFormArray]="filterSchema" [props]="props">
    </app-page-container>
    }
</div>
